// src/pages/Login.js
import React, { useState } from "react";
import { login } from "../api/authApi";
import { saveToken } from "../utils/auth";
import { useNavigate, Link } from "react-router-dom";
import "./Auth.css";

const Login = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const res = await login(form);
      saveToken(res.data.token);
      navigate("/");
    } catch (e) {
      setErr("Invalid credentials");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Login</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <label>Username</label>
          <input
            name="username"
            value={form.username}
            onChange={handleChange}
            placeholder="Enter username"
            required
          />
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Enter password"
            required
          />
          <button type="submit" className="auth-btn">
            Sign in
          </button>
        </form>
        {err && <p className="auth-msg error">{err}</p>}
        <div className="auth-footer">
          <Link to="/forgot-password">Forgot Password?</Link>
          <br />
          Don’t have an account? <Link to="/register">Register</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
